// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2CTbM","title":"InfoRow_title__1T5K_"};